import styled from 'styled-components';
import { borderRadius } from 'styles/variables';

export const YourHolidaysWrapper = styled.div`
  background-color: ${({ theme }) => theme.backgroundElement};
  border-radius: ${borderRadius.sm};
  margin: 1rem 0 1rem 0;
  padding: 1.5rem 0 0 0;
`;
